import { useEffect, useState } from "react";
import { baseContainer } from "@base-provider";

const CookiesHandler = ({cookies}) => {
  const [showCookiesBanner, setShowCookiesBanner] = useState(false);
  useEffect(() => {
    // Check if the user has accepted cookies before
    const hasAcceptedCookies = baseContainer.cookiesService.getCookiesStatus();
    if (hasAcceptedCookies !== "true") {
      // If the user has not accepted cookies before, show the banner
      setShowCookiesBanner(true);
      baseContainer.cookiesService.setCookiesStatus(false);
    }
  }, []);

  //Save that the user has accepted cookies to local storage and hide the banner
  const handleAcceptCookies = () => {
    setShowCookiesBanner(false);
    baseContainer.cookiesService.setCookiesStatus(true);
  };
  const Cookies= cookies;

  return (
    showCookiesBanner && <Cookies acceptCookies={handleAcceptCookies}/>
  );
};

export default CookiesHandler;
